/**
 * RD-SEC-015 — OS-appropriate app-store links for the MFA stepper's "no app
 * yet?" disclosure (Google Authenticator / Microsoft Authenticator "Obtener"
 * rows). Apple Passwords has no store link — it's built into iOS and has no
 * documented URL scheme, so its row is informational only (see
 * MfaAuthenticatorAppList).
 *
 * UA sniff for the STORE LINK ONLY — never layout (AGENTS.md: layout
 * decisions come from `useResponsiveLayout()`, never a raw UA/viewport
 * check). iOS → App Store; Android → Play Store; anything else (desktop,
 * unrecognized UA) falls back to the App Store link — most people reading
 * this screen are on a phone, and a desktop visitor can still open an
 * App Store link from their phone later.
 */
function detectMobilePlatform(userAgent) {
  return /Android/i.test(String(userAgent || '')) ? 'android' : 'ios';
}

const STORE_LINKS = {
  ios: {
    google: 'https://apps.apple.com/app/google-authenticator/id388497605',
    microsoft: 'https://apps.apple.com/app/microsoft-authenticator/id983156458',
  },
  android: {
    google: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
    microsoft: 'https://play.google.com/store/apps/details?id=com.azure.authenticator',
  },
};

/**
 * @param {string} [userAgent] — defaults to `navigator.userAgent` in the browser.
 * @returns {{ google: string, microsoft: string }}
 */
export function authenticatorStoreLinks(userAgent) {
  const ua = userAgent != null ? userAgent : (typeof navigator !== 'undefined' ? navigator.userAgent : '');
  return STORE_LINKS[detectMobilePlatform(ua)];
}

export default authenticatorStoreLinks;
